export interface ITierCondition {
  numericId: number;
  lenderCode: string;
  tierLabel: string;
  tierConditionId: string;
  tierId: string;
  rate: number;
  rateAdjustment: number;
  termGroup: number;
  ficoGroup: number;
  maxMarkup?: number;
  maxFlatFeePercent?: number;
  type: string;
  minTotalAmountFinanceGreen: number;
  minTotalAmountFinanceYellow: number;
  maxLtvGreen: number;
  maxLtvYellow: number;
  isCashOutRate?: boolean;
  maxAllInLtv: number;
  maxLoanAmount?: number;
  maxDti?: number;
  maxPti?: number;
  maxFlatGreen?: number;
  minFico: number;
}

export class TierConditionModel implements Partial<ITierCondition> {
  numericId?: number;
  lenderCode?: string;
  tierLabel?: string;
  tierConditionId?: string;
  tierId?: string;
  rate?: number;
  rateAdjustment?: number;
  termGroup?: number;
  ficoGroup?: number;
  maxMarkup?: number;
  maxFlatFeePercent?: number;
  type?: string;
  minTotalAmountFinanceGreen?: number;
  minTotalAmountFinanceYellow?: number;
  maxLtvGreen?: number;
  maxLtvYellow?: number;
  isCashOutRate?: boolean;
  maxAllInLtv?: number;
  maxLoanAmount?: number;
  maxDti?: number;
  maxPti?: number;
  maxFlatGreen?: number;

  constructor(data?: Partial<ITierCondition>) {
    if (data) {
      this.numericId = data?.numericId;
      this.lenderCode = data?.lenderCode;
      this.tierLabel = data?.tierLabel;
      this.tierConditionId = data?.tierConditionId;
      this.tierId = data?.tierId;
      this.rate = data?.rate;
      this.rateAdjustment = data?.rateAdjustment;
      this.termGroup = data?.termGroup;
      this.ficoGroup = data?.ficoGroup;
      this.maxMarkup = data?.maxMarkup;
      this.maxFlatFeePercent = data?.maxFlatFeePercent;
      this.minTotalAmountFinanceGreen = data?.minTotalAmountFinanceGreen;
      this.minTotalAmountFinanceYellow = data?.minTotalAmountFinanceYellow;
      this.maxLtvGreen = data?.maxLtvGreen;
      this.maxLtvYellow = data?.maxLtvYellow;
      this.isCashOutRate = data?.isCashOutRate;
      this.maxAllInLtv = data?.maxAllInLtv;
      this.maxLoanAmount = data?.maxLoanAmount;
      this.maxDti = data?.maxDti;
      this.maxPti = data?.maxPti;
      this.maxFlatGreen = data?.maxFlatGreen;
    }
  }
}
